import { Box, styled } from "@mui/system";
import React from "react";
import { FlexAlignCenter } from "./FlexBox";
import { CircularProgress } from "@mui/material";

  // const StyledLoading = styled(FlexAlignCenter)(() => ({
  //   width: "100%",
  //   height: "100%",

  //   "& img": { width: "auto", height: "100px" },
  //   "& .circleProgress": {
  //     // left: -7,
  //     right: 0,
  //     position: "absolute",
  //     top: "calc(50% - 25px)",
  //   },
  // }));

const StyledLoading = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& img': {
    width: 'auto',
    height: '25px'
  },
  '& .circleProgress': {
    position: 'absolute',
    // left: -7,
    left: "-13px",
    right: 0,
    // top: 'calc(50% - 23px)',
    top: 'calc(50% - 35px)',
  }
});


const Loading = () => {
  return (
    <StyledLoading>
      <Box position="relative">
        <img src="/assets/images/logo-circle_two.gif" className="loadProgress" alt="" style={{ borderRadius: '50px', height: '40px', width: '40px' }}/>
        <CircularProgress className="circleProgress" style={{ width: '65px', height: '65px',}}/>
      </Box>
    </StyledLoading>
  );
};

export default Loading;
